import { getAppRenderer } from './apps/registry.js';

export default function AppSlide({ item }) {
  const app = item?.app || {};
  const Renderer = getAppRenderer(app.kindId);
  return <Renderer app={app} item={item} />;
}
